import './VenueBlock.css';
import React from 'react';
import { get, getDictionaryItem, getListingItemURL } from '../../utils'; // eslint-disable-line
import LazyPicture from '../atoms/LazyPicture';
import IconStar from '../../resources/icons/star.svg';
import { injectImageResolution, pathJoin, getMediaHost } from '../../utils';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import ScrollAnimation from 'react-animate-on-scroll';
import ShortlistBtn from '../atoms/ShortlistBtn/ShortlistBtn';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';

//type is coming from M31_News module

var baseImage = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
var setDateFormat = function setDateFormat(date, lang) {
  return new Date(date).toLocaleDateString(lang, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};
var renderImage = function renderImage(item, width, height, alt, imgClassName, bannerClickAnalytics, params, hostLink) {
  if (!item.image) return null;
  var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), item.image])), width, height);
  return /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: getListingItemURL(hostLink, item.urlSlug, item.url),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), item.englishTitle);
    }
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeIn",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: imgClassName,
    src: imgSrc,
    alt: alt,
    "aria-hidden": "true"
  })), item.featured ? /*#__PURE__*/React.createElement("div", {
    className: "venue-block__img-feature"
  }) : null));
};
export var VenueBlock = function VenueBlock(_ref) {
  var item = _ref.item,
    copyBy = _ref.copyBy,
    copyMinread = _ref.copyMinread,
    lang = _ref.lang,
    hostLink = _ref.hostLink,
    callback = _ref.callback,
    analytics = _ref.analytics,
    dictionary = _ref.dictionary;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var renderLabel = function renderLabel(value, label) {
    if (label.indexOf('{value}') > -1) {
      label = label.replace('{value}', value);
    } else {
      label = "".concat(value, " ").concat(label);
    }
    return label;
  };
  var titleClickAnalytics = analytics.titleClickAnalytics,
    bannerClickAnalytics = analytics.bannerClickAnalytics,
    addToFavAnalytics = analytics.addToFavAnalytics,
    seeMoreAnalytics = analytics.seeMoreAnalytics,
    params = analytics.params;
  return /*#__PURE__*/React.createElement("div", {
    className: "article article-item ".concat(get(item, 'curators.curators.length') >= 1 ? 'has-no-curators' : '', " ").concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__image"
  }, /*#__PURE__*/React.createElement("div", {
    className: "small_image"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 0.8
  }, renderImage(item, 340, 243, 'Header', 'small_image', bannerClickAnalytics, params, hostLink))), /*#__PURE__*/React.createElement(ShortlistBtn, {
    id: item.objectID,
    sitecoreContext: sitecoreContext,
    title: item.title,
    analytics: {
      add: analytics.addToFavoriteAnalytics,
      remove: analytics.removeFromFavoriteAnalytics
    },
    params: params
  })), /*#__PURE__*/React.createElement("div", {
    className: "article__content"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "news__info-label-cnt d-block"
  }, item.category && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, item.category), item.category && item.featured ? /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, " \xB7 ") : '', item.featured && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label news__info-label--featured"
  }, getDictionaryItem(dictionary, 'featured'))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.05
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-medium article__title"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: getListingItemURL(hostLink, item.urlSlug, item.url),
    openInSameTab: true,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(titleClickAnalytics, params), item.englishTitle);
    }
  }, item.title))), parseInt(item.hotelStarRating) > 0 ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.10
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-block__stars"
  }, [/*#__PURE__*/React.createElement("img", {
    alt: "Star1",
    key: "1",
    src: IconStar
  }), /*#__PURE__*/React.createElement("img", {
    alt: "Star2",
    key: "2",
    src: IconStar
  }), /*#__PURE__*/React.createElement("img", {
    alt: "Star3",
    key: "3",
    src: IconStar
  }), /*#__PURE__*/React.createElement("img", {
    alt: "Star4",
    key: "4",
    src: IconStar
  }), /*#__PURE__*/React.createElement("img", {
    alt: "Star5",
    key: "5",
    src: IconStar
  })].slice(0, parseInt(item.hotelStarRating)))) : null, +item.totalHotelRooms || +item.totalMeetingRooms || +item.maxDelegates ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement("div", null, item.totalHotelRooms ? /*#__PURE__*/React.createElement("div", {
    className: "venue-block__option"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "21.722",
    height: "18.298",
    viewBox: "0 0 21.722 18.298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hotel_Room",
    "data-name": "Hotel Room",
    transform: "translate(0.05 0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M18.922,18.2a.5.5,0,0,1-.5-.5V15.25H3.217v2.444a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V8.807A2.92,2.92,0,0,1,.928,6.669l.043-.04V1.11A1.107,1.107,0,0,1,2,0H4.293a.5.5,0,0,1,.5.5V1H1.989V6.038l.176-.043a2.626,2.626,0,0,1,.43-.08h.118V4.3a1.11,1.11,0,0,1,1.11-1.11h5.4a1.11,1.11,0,0,1,1.11,1.11V5.9H11.3V4.3A1.11,1.11,0,0,1,12.4,3.192h5.419A1.107,1.107,0,0,1,18.931,4.3V5.9h.118a2.725,2.725,0,0,1,.433.08l.164.043V1.008H7.006A.5.5,0,0,1,6.5.5V0H19.55a1.107,1.107,0,0,1,1.1,1.11V6.629l.043.04a2.92,2.92,0,0,1,.928,2.137v8.887a.5.5,0,0,1-.5.5Zm0-3.953a.5.5,0,0,1,.5.5v2.444h1.2v-4.4H1.005v4.4h1.2V14.746a.5.5,0,0,1,.5-.5ZM2.9,6.9a1.884,1.884,0,0,0-1.9,1.905v2.982H20.626V8.807A1.881,1.881,0,0,0,18.73,6.9ZM12.3,5.9h5.639V4.2H12.3Zm-8.59,0H9.332V4.2H3.712Z",
    transform: "translate(0)",
    fill: "#747474",
    stroke: "#707070",
    "stroke-width": "0.1"
  }))), renderLabel(item.totalHotelRooms, getDictionaryItem(dictionary, 'hotel rooms'))) : null, item.totalMeetingRooms ? /*#__PURE__*/React.createElement("div", {
    className: "venue-block__option"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "26.201",
    height: "20.86",
    viewBox: "0 0 26.201 20.86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Meeting_room",
    "data-name": "Meeting room",
    transform: "translate(0.117 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M30.188,9.821a2.229,2.229,0,1,0,3.269,1.965h0a2.229,2.229,0,0,0-3.251-1.965Zm2.229,1.806h0V11.9a.477.477,0,0,1,0,.063,1.446,1.446,0,0,1-.045.182.918.918,0,0,1-.037.108h0v.019a1.729,1.729,0,0,1-.134.227l-.026.037-.056.063a1.263,1.263,0,0,1-.126.119l-.056.045-.093.059c-.033.022-.067.037-.1.056l-.052.026c-.071.026-.145.048-.215.067h-.435l-.115-.026a.925.925,0,0,1-.163-.052l-.071-.03-.1-.056-.093-.059-.041-.03a2.229,2.229,0,0,1-.167-.16l-.045-.056-.033-.048a2.058,2.058,0,0,1-.111-.2h0a.918.918,0,0,1-.037-.108.619.619,0,0,0-.03-.111c-.007-.037-.019-.1-.022-.108s0-.126,0-.186V11.63h0v-.041a1.631,1.631,0,0,1,.056-.223.357.357,0,0,1,.026-.074c-.022.067.03-.059.041-.082a1.426,1.426,0,0,1,.119-.186h0a.777.777,0,0,1,.074-.082l.082-.078.056-.045a1.732,1.732,0,0,1,.175-.111l.052-.026.071-.03a2.124,2.124,0,0,1,.219-.063h.137a2.14,2.14,0,0,1,.219,0h.078l.149.041.1.033c-.033,0,.074.033.093.045a1.928,1.928,0,0,1,.186.115c-.03,0,.059.052.074.067a1.423,1.423,0,0,1,.1.108l.045.048.056.085a.9.9,0,0,1,.074.13.371.371,0,0,1,.026.056,1.512,1.512,0,0,1,.074.253Z",
    transform: "translate(-18.236 -6.016)",
    fill: "#747474",
    stroke: "#707070",
    "stroke-width": "0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M53.166,23.278a2.367,2.367,0,0,0,.546,2.151,2.318,2.318,0,0,0,2.515.594,2.344,2.344,0,0,0,1.486-2.162h0a2.385,2.385,0,0,0-1.022-1.921,2.3,2.3,0,0,0-2.11-.245,2.355,2.355,0,0,0-1.416,1.583Zm.944.42V23.62a1.2,1.2,0,0,1,.037-.149.918.918,0,0,1,.037-.108.179.179,0,0,1,.019-.052,1.779,1.779,0,0,1,.093-.167.791.791,0,0,1,.059-.093h0a2.147,2.147,0,0,1,.182-.186l.045-.041c-.022.022.041-.03.059-.041s.126-.078.193-.115l.059-.026.063-.022a2.055,2.055,0,0,1,.26-.067h.074a1.811,1.811,0,0,1,.2,0h.1a1.5,1.5,0,0,1,.186.045.481.481,0,0,1,.141.045l.089.045c.056.03.108.063.16.1h.019l.056.045a1.6,1.6,0,0,1,.208.212,1.287,1.287,0,0,0,.074.111,1.393,1.393,0,0,1,.089.163v.019a.111.111,0,0,1,0,.037,1.486,1.486,0,0,1,.056.182,1.346,1.346,0,0,0,.026.145v.267a.417.417,0,0,0,0,.074.743.743,0,0,1-.041.175,1.127,1.127,0,0,1-.037.108l-.019.052a2.059,2.059,0,0,1-.111.2l-.03.048s-.037.048-.048.059a2.1,2.1,0,0,1-.156.16l-.048.041-.056.041a2.229,2.229,0,0,1-.227.13h0l-.108.037q-.111.033-.223.056h-.375l-.175-.041-.1-.045h-.052c-.056-.026-.111-.059-.167-.089l-.093-.063h0l-.033-.026a2.047,2.047,0,0,1-.16-.152l-.041-.048c.022.026-.03-.041-.041-.056s-.078-.13-.111-.193,0-.045-.03-.059l-.033-.126a1.541,1.541,0,0,1-.052-.227h0V23.88a1.459,1.459,0,0,1-.015-.182Z",
    transform: "translate(-33.381 -13.54)",
    fill: "#747474",
    stroke: "#707070",
    "stroke-width": "0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M25.974,29.262V28.3a3.058,3.058,0,0,0-.178-1.115,2.831,2.831,0,0,0-1.115-1.356.5.5,0,1,0-.505.866l.1.071h0c.063.048.123.108.182.163l.082.093.048.059a2.47,2.47,0,0,1,.134.208,1,1,0,0,1,.059.108.655.655,0,0,0,.033.074c.022.067.045.13.063.2a1.943,1.943,0,0,1,.045.2v1.787h0l-.026.067h0a.242.242,0,0,1-.015.1l-.063.033c.085-.041.03-.022,0,0H21.75l-1.82-3.344-.676-1.23a.5.5,0,0,0-.431-.245H16.593V23.852a2.824,2.824,0,0,0-.171-1.055,2.668,2.668,0,0,0-1.066-1.3.5.5,0,0,0-.505.866l.1.071h0l.052.041a2.285,2.285,0,0,1,.23.234h0l.033.048c.033.045.059.093.089.137a.925.925,0,0,1,.074.149v.071a2.028,2.028,0,0,1,.089.327.312.312,0,0,1,0,.037s0,.03,0,.045a1.374,1.374,0,0,1,0,.175v1.315H10.392V23.507a1.988,1.988,0,0,1,.071-.294,1.334,1.334,0,0,1,.045-.13c0,.048.041-.082.052-.1a2.051,2.051,0,0,1,.16-.253c-.022.03.059-.071.074-.085s.074-.078.115-.115a.777.777,0,0,1,.1-.089l.123-.048a.513.513,0,0,0,.182-.687.5.5,0,0,0-.687-.178,2.638,2.638,0,0,0-1.219,2.341v1.185H7.182a.5.5,0,0,0-.431.245L4.819,28.8l-.568,1.04H1.178L1.1,29.823h0l-.059-.048h0l-.022-.052a.071.071,0,0,1,0-.03.082.082,0,0,1,0-.033V27.924h0v-.071a2.029,2.029,0,0,1,.082-.338.227.227,0,0,0,.019-.045v-.03l.074-.149.089-.141.071-.093a2.7,2.7,0,0,1,.227-.208l.093-.078.1-.071a.5.5,0,1,0-.509-.866A2.779,2.779,0,0,0,.019,27.843a9.169,9.169,0,0,0-.03,1.148A2.2,2.2,0,0,0,.2,30.321a1.226,1.226,0,0,0,1,.524H3.7c-.241.412-.468.836-.695,1.245l-.713,1.3a.505.505,0,0,0,.431.743H23.243a.424.424,0,0,0,.152-.026.568.568,0,0,0,.1-.041.52.52,0,0,0,.182-.189v-.022h0a.472.472,0,0,0,.052-.215.531.531,0,0,0-.045-.2.2.2,0,0,0-.026-.048q-.68-1.271-1.378-2.545H24.77a1.2,1.2,0,0,0,1.066-.65,1.939,1.939,0,0,0,.137-.933Zm-9.151,3.882H3.575l1.4-2.549L6.93,27.021c.182-.327.372-.654.539-.981H18.5q.892,1.635,1.791,3.266t1.8,3.288l.3.55Z",
    transform: "translate(0 -13.476)",
    fill: "#747474",
    stroke: "#707070",
    "stroke-width": "0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M7.832,26.523a2.316,2.316,0,1,0-2.515-.594A2.311,2.311,0,0,0,7.832,26.523Zm-2.121-2.3a.658.658,0,0,1,0-.078.966.966,0,0,1,.037-.149.425.425,0,0,1,.033-.111L5.8,23.83a1.393,1.393,0,0,1,.089-.163l.059-.1h0a1.713,1.713,0,0,1,.178-.189l.048-.041.056-.041a2,2,0,0,1,.193-.111l.089-.048h.059a1.657,1.657,0,0,1,.26-.063H6.9a1.739,1.739,0,0,1,.2,0h.1a1.724,1.724,0,0,1,.189.041l.141.048.085.045a1.423,1.423,0,0,1,.163.093h0l.059.045a1.8,1.8,0,0,1,.2.208,1.014,1.014,0,0,0,.078.115c.033.052.059.108.089.163h0a.111.111,0,0,0,0,.037.839.839,0,0,0,.052.182c.015.059.026.149.026.145v.342c0,.015-.026.119-.041.175l-.033.108-.022.052a1.739,1.739,0,0,1-.111.2.308.308,0,0,1-.03.045L8,25.182a1.546,1.546,0,0,1-.156.156l-.045.045c.026-.022-.041.026-.056.037a1.583,1.583,0,0,1-.23.13h0l-.108.037a1.957,1.957,0,0,1-.223.052H6.807l-.137-.019-.108-.037a.286.286,0,0,1-.056-.022,1.393,1.393,0,0,1-.163-.089l-.093-.059h0l-.063-.045a1.271,1.271,0,0,1-.16-.156.256.256,0,0,1-.041-.048c.022.026-.03-.041-.041-.056a1.657,1.657,0,0,1-.115-.193L5.8,24.855l-.037-.1c-.022-.074-.037-.149-.052-.223h0v-.137a1.43,1.43,0,0,1,0-.175Z",
    transform: "translate(-2.964 -13.85)",
    fill: "#747474",
    stroke: "#707070",
    "stroke-width": "0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M14.649,7.6V1H28.53V7.6h0a1,1,0,0,0,1-1V.5a.505.505,0,0,0-.5-.5H14.152a.505.505,0,0,0-.5.5V6.595a1,1,0,0,0,1,1Z",
    transform: "translate(-8.589)",
    fill: "#747474",
    stroke: "#707070",
    "stroke-width": "0.2"
  }))), renderLabel(item.totalMeetingRooms, getDictionaryItem(dictionary, 'meeting rooms'))) : null, item.maxDelegates ? /*#__PURE__*/React.createElement("div", {
    className: "venue-block__option"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.022",
    height: "22.91",
    viewBox: "0 0 20.022 22.91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delegates",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M60.21,64.71v1.478a.764.764,0,0,0,.764.764h0V65.3a.586.586,0,0,0-.586-.586Z",
    transform: "translate(-41.352 -44.443)",
    fill: "#969696",
    stroke: "#707070",
    "stroke-width": "0.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M18.858,19.24v-.094a.583.583,0,0,0,.586.586h.179v-.5c-.028-1.074-1.121-2.142-2.593-2.534l-2.28-1.074-1.481-1.478H13.02V12.907h0a4.31,4.31,0,0,0,1.309-1.074l-.426-.188a.485.485,0,0,0-.52.075,6.123,6.123,0,0,1-1.641.94l-.232.1a4.072,4.072,0,0,1-1.716.432,4.072,4.072,0,0,1-1.713-.432l-.235-.1c-.651-.279-2.383-1.018-2.383-2.383V9.2l-.626-.792L4.77,8.359a.564.564,0,0,1-.251-.467V6.264l.94-.473V4.626A3.862,3.862,0,0,1,9.34.764h.94a3.859,3.859,0,0,1,3.862,3.862V5.8l.94.473V7.893a.564.564,0,0,1-.251.467l-.7.846v1.077a1.544,1.544,0,0,1-.041.385l.138.063a.482.482,0,0,0,.677-.442V9.471l.41-.517a1.322,1.322,0,0,0,.532-1.062V5.8l-.94-.473v-.7A4.623,4.623,0,0,0,10.282,0h-.94A4.626,4.626,0,0,0,4.714,4.626v.7l-.94.473v2.1A1.344,1.344,0,0,0,4.31,8.954l.407.517v.811A3.053,3.053,0,0,0,6.6,12.9l.016,1.253H6.364L4.886,15.629,2.6,16.69c-1.478.4-2.571,1.475-2.6,2.549v2.506a.764.764,0,0,0,.764.764h0v-3.26c.019-.723.918-1.525,2.077-1.835l2.152-1.005L7.4,19.3l.78-.626.3,1.5L8.218,21.2a.764.764,0,0,0,.554.94h0l.391-1.566h1.29l.391,1.566h0a.767.767,0,0,0,.557-.94l-.26-1.03.313-1.5.777.626,2.409-2.888,2.1.987.069.025C17.934,17.721,18.839,18.519,18.858,19.24ZM7.363,13.289l.207.088.185.081a4.748,4.748,0,0,0,2.055.514,4.764,4.764,0,0,0,2.058-.5l.166-.072.222-.1v1.046L9.809,16.383,7.363,14.345Zm.153,4.945L5.638,15.961l1.055-1.052h.175L9.23,16.875ZM10.448,19.8H9.2l-.332-1.66.962-.77.962.77Zm1.676-1.566-1.7-1.359,2.362-1.967h.175l1.046,1.065Z",
    fill: "#969696",
    stroke: "#707070",
    "stroke-width": "0.4"
  }))), renderLabel(item.maxDelegates, getDictionaryItem(dictionary, 'delegates'))) : null)) : null));
};
var commonStyles = "crzc5s7";
var ltrStyles = "l1ofxrd";
var rtlStyles = "r1j7op45";
export default VenueBlock;